import { _ as _objectWithoutProperties, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { MIN_WIDTH, MAX_WIDTH } from './constants.js';

const _excluded = ["items"];
const filterEmptyGroups = groups => {
  return groups.filter(({
    items
  }) => items.length > 0);
};
const filterGroupsBySearchString = (groups, searchString) => {
  return groups.map(_ref => {
    let {
        items
      } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread2(_objectSpread2({}, rest), {}, {
      items: items.filter(({
        title
      }) => title.toLowerCase().includes(searchString.toLowerCase()))
    });
  });
};
const getMaxNumberOfItems = groups => {
  let maxNumberOfItems = 0;
  groups.forEach(({
    items
  }) => {
    if (maxNumberOfItems < items.length) {
      maxNumberOfItems = items.length;
    }
  });
  return maxNumberOfItems;
};
const getContentWidth = groups => {
  const maxNumberOfItems = getMaxNumberOfItems(groups);
  if (maxNumberOfItems > 3) {
    return MAX_WIDTH;
  }
  return MIN_WIDTH;
};

export { filterEmptyGroups, filterGroupsBySearchString, getContentWidth };
